import { EmployeeProfileRoleDto } from '@/api/generated';
import { EmployeeProfileChatFormSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/employeeProfile.chat.translation.en.ts';
import { employeeProfileChatFastQuestionsManagerTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/fastQuestions/manager/employeeProfile.chat.fastQuestions.manager.translation.pl.ts';
import { employeeProfileChatFastQuestionsOwnerTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/fastQuestions/owner/employeeProfile.chat.fastQuestions.owner.translation.pl.ts';

export const employeeProfileChatFormSectionTranslation: EmployeeProfileChatFormSectionTranslation =
  {
    content: {
      askHim:
        'Zapytaj go o jego umiejętności, doświadczenie lub cokolwiek innego, co chcesz wiedzieć.',
      defaultTexts: {
        [EmployeeProfileRoleDto.Admin]: {
          description: 'Dowiedz się więcej o swoim pracowniku i jego umiejętnościach',
          headerTitle: 'Rozmowa o pracowniku',
          welcomeMessage:
            'Zadaj mi niestandardowe pytania o tego pracownika lub wybierz z najczęstszych poniżej.',
        },
        [EmployeeProfileRoleDto.AdminDevelopment]: {
          description: 'Dowiedz się więcej o swoim pracowniku i jego umiejętnościach',
          headerTitle: 'Rozmowa o pracowniku',
          welcomeMessage:
            'Zadaj mi niestandardowe pytania o tego pracownika lub wybierz z najczęstszych poniżej.',
        },
        [EmployeeProfileRoleDto.AdminSuccession]: {
          description: 'Dowiedz się więcej o swoim pracowniku i jego umiejętnościach',
          headerTitle: 'Rozmowa o pracowniku',
          welcomeMessage:
            'Zadaj mi niestandardowe pytania o tego pracownika lub wybierz z najczęstszych poniżej.',
        },
        [EmployeeProfileRoleDto.ForceAccess]: {
          description: 'Dowiedz się więcej o swoim pracowniku i jego umiejętnościach',
          headerTitle: 'Rozmowa o pracowniku',
          welcomeMessage:
            'Zadaj mi niestandardowe pytania o tego pracownika lub wybierz z najczęstszych poniżej.',
        },
        [EmployeeProfileRoleDto.HqHrbp]: {
          description: 'Dowiedz się więcej o swoim pracowniku i jego umiejętnościach',
          headerTitle: 'Rozmowa o pracowniku',
          welcomeMessage:
            'Zadaj mi niestandardowe pytania o tego pracownika lub wybierz z najczęstszych poniżej.',
        },
        [EmployeeProfileRoleDto.Hrbp]: {
          description: 'Dowiedz się więcej o swoim pracowniku i jego umiejętnościach',
          headerTitle: 'Rozmowa o pracowniku',
          welcomeMessage:
            'Zadaj mi niestandardowe pytania o tego pracownika lub wybierz z najczęstszych poniżej.',
        },
        [EmployeeProfileRoleDto.NoAccess]: {
          description: '',
          headerTitle: '',
          welcomeMessage: '',
        },
        [EmployeeProfileRoleDto.Owner]: {
          description: 'Otrzymaj spersonalizowane wskazówki dotyczące rozwoju zawodowego i kariery',
          headerTitle: 'Twój chat',
          welcomeMessage:
            'Cześć! Jestem tutaj, aby pomóc Ci w rozwoju zawodowym i budowaniu kariery. Co chciałbyś dziś odkryć?',
        },
        [EmployeeProfileRoleDto.P1]: {
          description: 'Dowiedz się więcej o swoim pracowniku i jego umiejętnościach',
          headerTitle: 'Rozmowa o pracowniku',
          welcomeMessage:
            'Zadaj mi niestandardowe pytania o tego pracownika lub wybierz z najczęstszych poniżej.',
        },
        [EmployeeProfileRoleDto.P2]: {
          description: 'Dowiedz się więcej o swoim pracowniku i jego umiejętnościach',
          headerTitle: 'Rozmowa o pracowniku',
          welcomeMessage:
            'Zadaj mi niestandardowe pytania o tego pracownika lub wybierz z najczęstszych poniżej.',
        },
      },
      form: {
        enterMessage: 'Napisz wiadomość...',
        fastQuestions: 'Szybkie pytania',
        streamingError: 'Wystąpił błąd, proszę spróbować ponownie później',
      },
      noMessages: 'Rozpocznij rozmowę z wirtualnym asystentem na temat wybranego pracownika.',
      questionsPerRole: {
        [EmployeeProfileRoleDto.Admin]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.AdminDevelopment]:
          employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.AdminSuccession]:
          employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.ForceAccess]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.HqHrbp]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.Hrbp]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.NoAccess]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.Owner]: employeeProfileChatFastQuestionsOwnerTranslation,
        [EmployeeProfileRoleDto.P1]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.P2]: employeeProfileChatFastQuestionsManagerTranslation,
      },
    },
    headerTitle: 'Chat',
    headerTitleShorter: 'Chat',
  };
